module.exports = __webpack_public_path__ + "e79c35c31e1377fe7ef5bb33097e3340.svg";